import React, { useMemo } from 'react'
import classNames from 'classnames'

import { LntMenu, LntDivider } from '@app/components/base'

import { BUTTON_POSITION } from './constants'

import { CollapseButton } from './CollapseButton'
import { SideMenuFooter } from './SideMenuFooter'
import { SideMenuHeader } from './SideMenuHeader'

import { getItemsWithCollapseElement } from './utils'

import styles from './styles.module.scss'

import type { Key } from 'react'
import type { MenuItemGroup } from '@app/types/menu'
import type { SideMenuProps } from './types'

const DEFAULT_COLLAPSE_ELEMENT = <LntDivider className={ styles.sideMenu__divider } />

export const SideMenu: React.FC<SideMenuProps> = props => {
  const {
    items: rawItems,
    className: outerClassName,
    isCollapse,
    selectedKey,
    collapseElement = DEFAULT_COLLAPSE_ELEMENT,
    onMenuItemClick,
    onCollapseButtonClick
  } = props

  const className: string = classNames(styles.sideMenu, { [styles.sideMenu_collapse]: isCollapse }, outerClassName)

  const items: MenuItemGroup[] | undefined = useMemo(() => {
    if (rawItems && isCollapse) {
      return getItemsWithCollapseElement(rawItems, collapseElement)
    }

    return rawItems
  }, [rawItems, isCollapse])

  const handleClick = (info: { key: Key }): void => onMenuItemClick?.(info.key)

  return (
    <aside className={ className }>
      <nav className={ styles.sideMenu__nav }>
        <SideMenuHeader isCollapse={ isCollapse } />

        <div className={ styles.sideMenu__wrapper }>
          <LntMenu
            mode='inline'
            selectedKeys={ selectedKey ? [selectedKey] : undefined }
            className={ styles.sideMenu__menu }
            items={ items }
            inlineCollapsed={ isCollapse }
            onClick={ handleClick }
          />
        </div>

        <SideMenuFooter>
          <CollapseButton
            isCollapse={ isCollapse }
            position={ BUTTON_POSITION }
            onClick={ onCollapseButtonClick }
          />
        </SideMenuFooter>
      </nav>
    </aside>
  )
}
